import axiosClient from './axiosClient'

const partnerApi = {
  create: (body) => {
    const url = '/partner/set-hsm-update_inforRabbitmq'
    return axiosClient.post(url, body)
  },
  pauseInvoiceQueuePartner: (params) => {
    const url = '/tvanHandle/pauseInvoiceQueuePartner'
    return axiosClient.get(url, { params })
  },
}

export default partnerApi
